const corporateRetail = {
  // HeroSection
  'corporateRetail.hero.homeLink': 'ホーム',
  'corporateRetail.hero.corporateLink': '法人研修',
  'corporateRetail.hero.currentPage': '百貨店外商・高級小売向け',
  'corporateRetail.hero.title': '百貨店外商・高級小売向け 法人研修',
  'corporateRetail.hero.titleEn': 'FOR DEPARTMENT STORES & LUXURY RETAIL',
  'corporateRetail.hero.lead': '外商・高級小売向け研修は、日本の執事学校がお得意様対応と訪問の作法を執事の基準で磨き上げるプログラムです。',
  'corporateRetail.hero.cta': 'この業種で相談する',
  'corporateRetail.hero.imgAlt': '店内のVIPルームでお得意様に商品を両手で提示する日本人外商担当者',
  'corporateRetail.hero.badge1': '訪問の作法を執事の基準で体系化',
  'corporateRetail.hero.badge2': '出張型で店舗バックヤード・会議室にて実施',
  'corporateRetail.hero.badge3': '執事養成課程と同一の講師陣',

  // PainPoints
  'corporateRetail.pain.label': 'CHALLENGES',
  'corporateRetail.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateRetail.pain.titleEn': 'Common Challenges',
  'corporateRetail.pain.lead': 'お得意様との関係は、商品力だけでは続きません。ご自宅へ伺う足の運び、商品を差し出す手元、辞去の引き際にこそ、外商の格が表れます。',
  'corporateRetail.pain.0': 'お得意様のご自宅やご勤務先へ伺う際の作法を、体系立てて教えられていません。訪問のマナーは先輩の背中を見て覚える属人的な伝承に頼っており、担当者ごとに振る舞いの質に差が出ています。',
  'corporateRetail.pain.1': '商品知識は十分に備わっている一方で、所作・言葉遣い・身だしなみが商品の格に追いついていません。高額品を扱うからこそ、担当者自身の立ち居振る舞いが商品価値の一部としてお客様に映ります。',
  'corporateRetail.pain.2': '高額品の提示・受け渡し・お包みの美しさに個人差があります。外商では、商品を差し出す手元の所作そのものが「信頼の証」です。包み方ひとつでお客様に与える印象は大きく変わります。',
  'corporateRetail.pain.3': '次世代のお得意様——若い富裕層との関係づくりに苦戦しています。従来のご挨拶回りだけでは通用しない新しいお得意様層に対し、押し付けがましくない信頼構築の技術が求められています。',

  // WhyButlerWorks
  'corporateRetail.why.label': 'WHY BUTLER METHOD',
  'corporateRetail.why.title': 'なぜ執事の作法が外商に効くのか？',
  'corporateRetail.why.titleEn': 'Why the Butler Approach Works',
  'corporateRetail.why.lead1': '主の私邸という最もプライベートな空間で仕えてきた執事の作法は、訪問の作法の原型です。手元の所作まで実技で磨きます。',
  'corporateRetail.why.lead2': '本研修が提供するのは、プロの執事が培った接遇の型を、貴社の現場で使えるビジネスマナーとして移植することです。',
  'corporateRetail.why.0.title': '主の私邸で仕える執事の作法は、訪問の作法の原型である',
  'corporateRetail.why.0.desc': '執事は、主の自宅という最もプライベートな空間で仕えてきた職業です。玄関先でのご挨拶、室内での立ち居振る舞い、辞去のタイミング——これらはすべて外商担当者が日々直面する場面と直結しています。訪問の作法を、最も蓄積のある職業から学びます。',
  'corporateRetail.why.1.title': '「売る所作」ではなく「仕える所作」を訓練する',
  'corporateRetail.why.1.desc': '「商品を売り込む」姿勢ではなく、「お客様にお仕えする」所作を実技で繰り返し訓練することで、押し付け感のない自然な提案姿勢が身につきます。外商のお得意様が最も評価するのは、商品知識以上に「この人なら任せられる」という安心感です。',
  'corporateRetail.why.2.title': '提示・受け渡し・包み——手元の所作を細部まで矯正する',
  'corporateRetail.why.2.desc': '風呂敷の扱い、化粧箱の開け閉め、商品を両手で差し出す角度と高さ。お客様が無意識に注視する手元の所作を、実技で細部まで矯正します。手元が美しいだけで、商品の格は一段上がります。',

  // RecommendedPrograms
  'corporateRetail.rec.label': 'RECOMMENDED',
  'corporateRetail.rec.title': '推奨プログラム構成',
  'corporateRetail.rec.titleEn': 'Program Examples for Department Stores & Luxury Retail',
  'corporateRetail.rec.lead': '貴社の商材と売場環境に合わせて、最適な研修構成をご提案します。商品知識研修を否定するものではなく、接遇の土台を補完する形でお役立ていただくことを想定しています。',
  'corporateRetail.rec.badge': '標準',
  'corporateRetail.rec.priceSuffix': '円（税込）',
  'corporateRetail.rec.corporateLink': '法人研修総合ページ',
  'corporateRetail.rec.corporateLinkText': 'モジュールの詳細は',
  'corporateRetail.rec.corporateLinkSuffix': 'をご覧ください。',
  'corporateRetail.rec.0.duration': '3時間',
  'corporateRetail.rec.0.modules': 'M1（立ち居振る舞い）＋ M3（提示・受け渡し実技）※小売向けにアレンジ',
  'corporateRetail.rec.0.description': '立ち居振る舞いの基本と、商品提示・受け渡しの手元所作に集中する短期プランです。売場の隙間時間を活用した導入研修としてご利用いただけます。',
  'corporateRetail.rec.1.duration': '6時間',
  'corporateRetail.rec.1.modules': 'M1 ＋ M2（VIP・富裕層対応の原則）＋ M3 ＋ M4（お断り・代替提案ロールプレイング）',
  'corporateRetail.rec.1.description': '所作からVIP対応、お断りの伝え方まで、外商・高級小売の接遇基盤を1日で網羅する推奨プランです。閉店後の夜間開催にも対応します。',
  'corporateRetail.rec.2.duration': '1日（6時間）×店舗数',
  'corporateRetail.rec.2.modules': '1店舗あたり1日。2店舗目以降は同一単価',
  'corporateRetail.rec.2.description': '複数店舗を巡回して順次実施するプランです。店舗ごとの売場環境に合わせた演習内容に調整し、全店で統一された接遇品質を実現します。',

  // ScenarioTraining
  'corporateRetail.scenario.label': 'SCENARIOS',
  'corporateRetail.scenario.title': '外商・高級小売特化の演習シナリオ',
  'corporateRetail.scenario.titleEn': 'Retail Training Scenarios',
  'corporateRetail.scenario.lead': '研修は売場と訪問先の実際の場面を再現して行います。代表的なシナリオを三つご紹介します。シナリオは貴社の商材・売場に合わせて差し替え可能です。',
  'corporateRetail.scenario.note': '※シナリオは貴社の商材・売場に合わせて差し替え可能です。和室での所作（座礼・畳の上での商品提示）を含む演習にも対応します。',
  'corporateRetail.scenario.0.title': 'お得意様宅への訪問',
  'corporateRetail.scenario.0.desc': '玄関先でのご挨拶、風呂敷やケースから商品を取り出してお見せする所作、お包みしてのお渡し、辞去の引き際までを通しで演習します。和室での座礼や畳の上での商品提示といった場面も含み、お得意様の生活空間に即した振る舞いを磨きます。お届けの品をどのように扱い、どのタイミングで退出するか——すべての所作に意味があります。',
  'corporateRetail.scenario.1.title': 'VIPルーム・サロンでの接客',
  'corporateRetail.scenario.1.desc': 'ご来店からVIPルームへのご案内、お席へのエスコート、お茶出しの所作、商品提示の角度と距離感、お包みまでの一連の流れを実技で確認します。高額品の商談では、商談室の空気そのものがお客様の購買意欲に影響します。空間を統べる所作を体系化します。',
  'corporateRetail.scenario.2.title': 'ご要望に沿えない場面での対応',
  'corporateRetail.scenario.2.desc': '在庫切れ・取り扱い外のご要望に対し、お断りと代替提案をどのように組み立てるかをロールプレイングします。「お役に立てない」という状況でも、お客様の尊厳を守り、次のご来店につなげる対応を訓練します。外商において、断り方の巧拙は信頼に直結します。',

  // TargetRoles
  'corporateRetail.target.label': 'TARGET',
  'corporateRetail.target.title': '対象職種・推奨人数',
  'corporateRetail.target.titleEn': 'Target Roles & Capacity',
  'corporateRetail.target.lead': '外商部門から売場の販売員まで、お客様と直接接するすべての職種の皆様にご受講いただけます。実技の品質を保つため、1回の研修は12名までを推奨しています。',
  'corporateRetail.target.capacity': '推奨12名まで',
  'corporateRetail.target.capacityNote': '超過する場合は2班制等をご提案します。複数店舗からの合同参加にも対応。店舗バックヤード・会議室への出張実施が可能で、閉店後の夜間開催も承ります。',
  'corporateRetail.target.role0': '外商担当',
  'corporateRetail.target.role1': 'VIPルーム・サロン担当',
  'corporateRetail.target.role2': '店長・売場責任者',
  'corporateRetail.target.role3': '高級ブランド販売員',
  'corporateRetail.target.role4': 'ギフトサロン担当',

  // PricingTable
  'corporateRetail.pricing.label': 'PRICING',
  'corporateRetail.pricing.title': '料金プラン',
  'corporateRetail.pricing.titleEn': 'Transparent Pricing',
  'corporateRetail.pricing.lead': 'すべて税込価格での明確な料金体系です。貴社のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporateRetail.pricing.colPlan': 'プラン',
  'corporateRetail.pricing.colDuration': '時間',
  'corporateRetail.pricing.colPrice': '料金（税込）',
  'corporateRetail.pricing.colNote': '内容',
  'corporateRetail.pricing.badge': '標準',
  'corporateRetail.pricing.priceSuffix': '円',
  'corporateRetail.pricing.conditionsTitle': '共通条件',
  'corporateRetail.pricing.corporateLinkText': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateRetail.pricing.corporateLink': '法人研修総合ページ',
  'corporateRetail.pricing.corporateLinkSuffix': 'をご覧ください。',
  'corporateRetail.pricing.cta': '研修について問い合わせる',
  'corporateRetail.pricing.plan0.name': '半日プラン',
  'corporateRetail.pricing.plan0.duration': '3時間',
  'corporateRetail.pricing.plan0.note': '2モジュール選択',
  'corporateRetail.pricing.plan1.name': '1日プラン',
  'corporateRetail.pricing.plan1.duration': '6時間',
  'corporateRetail.pricing.plan1.note': '4モジュール選択',
  'corporateRetail.pricing.plan2.name': '2日間パッケージ',
  'corporateRetail.pricing.plan2.duration': '2日間（各6時間）',
  'corporateRetail.pricing.plan2.note': '全モジュール対応',
  'corporateRetail.pricing.plan3.name': '継続プログラム',
  'corporateRetail.pricing.plan3.duration': '月1回半日×6ヶ月',
  'corporateRetail.pricing.plan3.note': '定着と改善を繰り返す長期設計',
  'corporateRetail.pricing.cond.dispatch': '出張時の交通費は実費別途',
  'corporateRetail.pricing.cond.capacity': '推奨12名まで。超過する場合は2班制等をご提案します。複数店舗からの合同参加も対応可能です。',
  'corporateRetail.pricing.cond.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateRetail.pricing.cond.night': '閉店後の夜間開催・複数店舗での巡回開催に対応します。',
  'corporateRetail.pricing.cond.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',

  // FlowSteps
  'corporateRetail.flow.label': 'FLOW',
  'corporateRetail.flow.title': 'ご利用の流れ',
  'corporateRetail.flow.titleEn': 'From Inquiry to Results',
  'corporateRetail.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで着実に進めます。研修内容の事前資料をお送りできますので、稟議のご準備にもご活用ください。なお、歳暮・中元などの催事繁忙期を避けた日程のご提案も承ります。',
  'corporateRetail.flow.step0.title': 'お問い合わせ',
  'corporateRetail.flow.step0.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateRetail.flow.step1.title': 'ヒアリング',
  'corporateRetail.flow.step1.desc': '対象人数・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。なお、歳暮・中元などの催事繁忙期を避けた日程のご提案も承ります。',
  'corporateRetail.flow.step2.title': 'プログラム提案・お見積り',
  'corporateRetail.flow.step2.desc': 'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。事前に研修内容資料をお送りできますので、稟議のご準備にもご活用ください。概算お見積りのみのご依頼でも構いません。',
  'corporateRetail.flow.step3.title': '実施',
  'corporateRetail.flow.step3.desc': '出張または来校にて研修を実施します。出張型では貴社の店舗バックヤード・会議室を使用し、実際の売場動線で訓練することで研修翌日からの再現性が高まります。閉店後の夜間開催や、複数店舗を巡回する形での実施にも対応します。',
  'corporateRetail.flow.step4.title': '実施後レポート',
  'corporateRetail.flow.step4.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporateRetail.contact.label': 'CONTACT',
  'corporateRetail.contact.title': 'お問い合わせ',
  'corporateRetail.contact.titleEn': 'Inquiry Form',
  'corporateRetail.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateRetail.contact.phoneText': 'フォームのほか、お電話',
  'corporateRetail.contact.phoneOr': 'またはメール',
  'corporateRetail.contact.phoneAccept': 'でも承ります。',
  'corporateRetail.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateRetail.contact.company': '会社名',
  'corporateRetail.contact.department': '部署・役職',
  'corporateRetail.contact.name': 'ご担当者名',
  'corporateRetail.contact.nameRequired': '必須',
  'corporateRetail.contact.namePlaceholder': '例: 執事 太郎',
  'corporateRetail.contact.nameError': 'ご担当者名は必須です',
  'corporateRetail.contact.email': 'メールアドレス',
  'corporateRetail.contact.emailRequired': '必須',
  'corporateRetail.contact.emailPlaceholder': '例: taro@example.com',
  'corporateRetail.contact.emailError': 'メールアドレスは必須です',
  'corporateRetail.contact.emailInvalidError': '有効なメールアドレスを入力してください',
  'corporateRetail.contact.phone': '電話番号',
  'corporateRetail.contact.phoneRequired': '必須',
  'corporateRetail.contact.phonePlaceholder': '例: 090-1234-5678',
  'corporateRetail.contact.phoneError': '電話番号は必須です',
  'corporateRetail.contact.businessType': '業態',
  'corporateRetail.contact.businessTypeRequired': '必須',
  'corporateRetail.contact.businessTypeError': '業態をお選びください',
  'corporateRetail.contact.format': '希望形式',
  'corporateRetail.contact.participants': '想定人数',
  'corporateRetail.contact.participantsPlaceholder': '例: 10名',
  'corporateRetail.contact.timeline': '検討時期',
  'corporateRetail.contact.timelinePlaceholder': '例: 来月、今期中、未定',
  'corporateRetail.contact.message': 'ご相談内容（任意）',
  'corporateRetail.contact.messagePlaceholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateRetail.contact.messageMax': '500文字以内で入力してください',
  'corporateRetail.contact.submitError': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateRetail.contact.submitting': '送信中...',
  'corporateRetail.contact.submit': 'この内容で送信する',
  'corporateRetail.contact.companyPlaceholder': '例: 株式会社〇〇',
  'corporateRetail.contact.departmentPlaceholder': '例: 外商部',
  'corporateRetail.contact.bizOpt0': '選択してください',
  'corporateRetail.contact.bizOpt1': '百貨店外商',
  'corporateRetail.contact.bizOpt2': '百貨店売場',
  'corporateRetail.contact.bizOpt3': '高級ブランド',
  'corporateRetail.contact.bizOpt4': '専門店',
  'corporateRetail.contact.bizOpt5': 'その他',
  'corporateRetail.contact.fmtOpt0': '選択してください',
  'corporateRetail.contact.fmtOpt1': '出張',
  'corporateRetail.contact.fmtOpt2': '来校',
  'corporateRetail.contact.fmtOpt3': '未定',

  // FAQSection
  'corporateRetail.faq.label': 'FAQ',
  'corporateRetail.faq.title': 'よくあるご質問',
  'corporateRetail.faq.titleEn': 'Frequently Asked Questions',
  'corporateRetail.faq.note': 'その他のご質問はフォームよりお寄せください',
  'corporateRetail.faq.0.q': '執事の資格が取れる研修ですか？',
  'corporateRetail.faq.0.a': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateRetail.faq.1.q': '閉店後の夜間に実施できますか？',
  'corporateRetail.faq.1.a': 'はい、対応します。開始時刻と会場条件をヒアリング時にお知らせください。外商部門の皆様の勤務実態を踏まえ、柔軟に日程を設定します。',
  'corporateRetail.faq.2.q': '一般的な販売ロールプレイング研修と何が違いますか？',
  'corporateRetail.faq.2.a': '販売トークではなく、訪問・提示・受け渡しといった「仕える所作」を実技で鍛える点が違いです。商品知識研修と併用いただく形を推奨しています。商談技法の研修を否定するものではなく、接遇の土台を補完する役割です。',
  'corporateRetail.faq.3.q': '複数店舗をまとめて実施できますか？',
  'corporateRetail.faq.3.a': 'はい。合同開催のほか、店舗を巡回する複数回開催もご提案できます。各店舗の売場環境や商材に合わせて演習内容を調整しますので、ヒアリング時に店舗数とご希望のスケジュール感をお聞かせください。',

  // CTASection
  'corporateRetail.cta.label': 'GET STARTED',
  'corporateRetail.cta.title': 'まずはお気軽にご相談ください',
  'corporateRetail.cta.lead': '閉店後の夜間開催や複数店舗での巡回開催も組めます。まずは店舗数とご希望の時期をお聞かせください。',
  'corporateRetail.cta.sub': '貴社の商材やお客様層をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateRetail.cta.inquiry': '研修について問い合わせる',
  'corporateRetail.cta.courses': '個人向けコースを見る',

  // RelatedPages
  'corporateRetail.related.label': 'OTHER INDUSTRIES',
  'corporateRetail.related.title': '他の業種向けプログラム',
  'corporateRetail.related.titleEn': 'Training for Other Industries',
  'corporateRetail.related.viewLink': '詳しく見る',
  'corporateRetail.related.corporateBack': '法人研修総合ページへ戻る',
  'corporateRetail.related.coursesLink': '個人向けコース（執事養成課程）を見る',
  'corporateRetail.related.0.title': 'ホテル・旅館',
  'corporateRetail.related.0.desc': 'バトラーサービスの型を開業前に整える',
  'corporateRetail.related.1.title': '高級レジデンス',
  'corporateRetail.related.1.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateRetail.related.2.title': '金融・プライベートバンク',
  'corporateRetail.related.2.desc': '富裕層営業の所作と距離感を鍛える',
  'corporateRetail.related.3.title': 'ラグジュアリー営業',
  'corporateRetail.related.3.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateRetail.related.4.title': '医療・美容クリニック',
  'corporateRetail.related.4.desc': '自由診療の接遇を院内に定着',
  'corporateRetail.related.5.title': '自動車・モビリティ',
  'corporateRetail.related.5.desc': 'ブランド体験の接遇を高める',
  'corporateRetail.related.6.title': 'ハイヤー・送迎',
  'corporateRetail.related.6.desc': '乗降の所作と車内の気配りを磨く',

  // page.tsx
  'corporateRetail.page.lastUpdated': '最終更新: 2026年6月13日',
};

export default corporateRetail;
